import React from 'react';
import ChartistGraph from 'react-chartist';
import "../../player-overview-charts/chartist.min.css";
import "./chart-custom-theme.css";

class AngleChart extends React.Component {
    componentWillMount() {
      this.setState({});
    }

    componentDidMount() {
      let anglesSequence = -1;
      if (this.props.result.angles_sequence) {
        anglesSequence = this.props.result.angles_sequence
        this.setState({
          ...this.state,
          angles_sequence: anglesSequence.split(","),
          current_angle_index: 0
        })
      }
    }

    startAnimating () {
        if (this.state.animation_interval && this.state.animation_interval !== -1) {
          return;
        }

        if (this.props.dynamic === false) {
          return;
        }

        var animationInterval = setInterval(this.animateChart.bind(this), 20);
        this.setState({
          ...this.state,
            animating: true,
            current_angle_index: 0,
            animation_interval: animationInterval
        });
        console.log('enter');
    }

    stopAnimating () {
        clearInterval(this.state.animation_interval)
        this.setState({
            ...this.state,
            animating: false,
            current_angle_index: 0,
            animation_interval: -1
        });
        console.log('leave');
    }

    animateChart () {
      if (!this.state.angles_sequence) {
        return;
      }

      let index = this.state.current_angle_index;
      let sequence = this.state.angles_sequence;
      if (index >= sequence.length) {
        this.stopAnimating();
        return;
      }

      let currentFrameData = this.state.angles_sequence[this.state.current_angle_index];

      let newAnimationFrame;
      let fillData;
      if (currentFrameData < 0) {
        currentFrameData *= -1;
        fillData = 90 - currentFrameData;
        newAnimationFrame = [fillData, currentFrameData, 0, 90];
      }
      else {
        fillData = 90 - currentFrameData;
        newAnimationFrame = [90, 0, currentFrameData, fillData];
      }

      this.setState({
        ...this.state,
        animationFrame: newAnimationFrame,
        current_angle_index: this.state.current_angle_index + 1
      })
    }

    render() {

        let dynamic = typeof this.props.dynamic !== "undefined" ? this.props.dynamic : true;

        let maxAngleLeft = Math.round(this.props.result.max_angle_left);
        let maxAngleRight = Math.round(this.props.result.max_angle_right);
        let anglesNotReachedLeft = 90- maxAngleLeft;
        let anglesNotReachedRight = 90 - maxAngleRight;
        let seriesAll = [anglesNotReachedLeft, maxAngleLeft, maxAngleRight, anglesNotReachedRight];

        if (dynamic) {
          if (this.state.animating) {
            seriesAll = this.state.animationFrame;
            if (seriesAll) {
              maxAngleLeft = seriesAll[1];
              maxAngleRight = seriesAll[2];
            }

          }
        }

        const showText = typeof this.props.show_text !== "undefined" ? this.props.show_text : true
        if (typeof maxAngleLeft === "undefined") {
            return (
                <div className='chart-spinner-container'>
                    <i className='fa fa-spinner fa-spin'/>
                </div>
            );
        }

        var data =  {
          series: seriesAll
        }

        var options = {
          donut: true,
          donutWidth: 40,
          startAngle: 270,
          total: 360,
          showLabel: false
        };
        const type = 'Pie';

        let leftLabel = this.props.result.hand === 0 ? "Pronation" : "Supination";
        let rightLabel = this.props.result.hand === 0 ? "Supination" : "Pronation";

        return (
            <div>
              {
                  showText &&
                    <div>
                      <div className='angle_chart_title'>Hand Used</div>
                      <div>{ this.props.result.hand === 0 ? "Left" : "Right" }</div>
                      <div className='angle_chart_title'>Angle Reach</div>
                    </div>

              }

              <div><span style={{marginRight: '7px'}}>{leftLabel}: <b>{maxAngleLeft}°</b></span><span>{rightLabel}: <b>{maxAngleRight}°</b></span></div>
              <div className='angle_chart_holder'>
                <ChartistGraph data={data} options={options} type={type}/>
                {
                  dynamic &&
                  <div className='angle_chart_buttons'>
                    {
                      !this.state.animating && <div onClick={this.startAnimating.bind(this)} className='angle_play_button angle_chart_button'><i class='fa fa-play'></i></div>
                    }
                    {
                      this.state.animating && <div onClick={this.stopAnimating.bind(this)} className='angle_stop_button angle_chart_button'><i class='fa fa-stop'></i></div>
                    }
                  </div>
                }
              </div>

            </div>
        )
    }
}

export default AngleChart;



// WEBPACK FOOTER //
// ./src/components/components/results/angle-chart/angle-chart.js